import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
`;

export const CurrentlyInfoSection = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const TokenCost = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TokenCostDescription = styled.div`
  font-size: 12px;
  line-height: 15px;
  color: var(--text-secondary);
`;

export const TokenIconWrapper = styled.div<{ $background: string }>`
  display: flex;
  padding: 12px;
  border-radius: 8px;
  background: ${({ $background }) => $background};
  svg {
    width: 24px;
    path {
      fill: #fff;
    }
  }
`;

export const ZoomSection = styled.div`
  position: absolute;
  right: 0;
  bottom: 36px;
  padding: 4px;
  border-radius: 8px;
  display: flex;
  column-gap: 6px;
`;

export const ZoomButton = styled.div<{ $disabled?: boolean }>`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.9;
  pointer-events: auto;
  background-color: var(--fill-secondary);
  user-select: none;
  cursor: pointer;
  &:hover {
    opacity: 0.4;
  }
  svg path {
    fill: var(--fill-primary);
  }
  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;
